/**
 * Illustrative System Logs seed rows — cover Admin / System activity across
 * modules wired into Change History and related platform processes.
 * Not live production evidence.
 */

export const INITIAL_ACTIVITY = [
  {
    id: 'act-1',
    loggedOn: '2026-08-11 09:40 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T09:40:00Z',
    source: 'Trade Categories',
    action: 'Save Trade Category',
    actionBy: 'Platform Owner — Saim Sahi',
    permissionScope: 'Trade Categories Management',
    environment: 'Production',
    service: 'Admin Console',
    result: 'Success',
    referenceId: 'TC-ACT-000318',
    details: 'Electrical subcategory Industrial added',
  },
  {
    id: 'act-2',
    loggedOn: '2026-08-11 08:45 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T08:45:00Z',
    source: 'Pricing Plans',
    action: 'Schedule Price Change',
    actionBy: 'Platform Owner — Saim Sahi',
    permissionScope: 'Pricing Plans',
    environment: 'Production',
    service: 'Admin Console',
    result: 'Success',
    referenceId: 'PP-ACT-000214',
    details: 'Pro Plan pending monthly cost scheduled',
  },
  {
    id: 'act-3',
    loggedOn: '2026-08-11 07:20 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T07:20:00Z',
    source: 'Configuration — Search Matching',
    action: 'Save Rule',
    actionBy: 'Development — Alex Morgan',
    permissionScope: 'Configuration',
    environment: 'Production',
    service: 'Admin Console',
    result: 'Success',
    referenceId: 'SMR-ACT-000091',
    details: 'Default search radius updated to 15 km',
  },
  {
    id: 'act-4',
    loggedOn: '2026-08-11 06:55 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T06:55:00Z',
    source: 'Moderation',
    action: 'Final Decision',
    actionBy: 'Support Team — Alex Morgan',
    permissionScope: 'Moderation',
    environment: 'Production',
    service: 'Admin Console',
    result: 'Success',
    referenceId: 'MOD-ACT-000412',
    details: 'Hide Content applied to Post POST-004701',
  },
  {
    id: 'act-5',
    loggedOn: '2026-08-11 05:50 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T05:50:00Z',
    source: 'Compliance',
    action: 'Approve Case',
    actionBy: 'Configuration Admin — Olivia Brown',
    permissionScope: 'Compliance',
    environment: 'Production',
    service: 'Admin Console',
    result: 'Success',
    referenceId: 'CMP-ACT-000155',
    details: 'Licence case approved; business record created',
  },
  {
    id: 'act-6',
    loggedOn: '2026-08-11 04:25 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T04:25:00Z',
    source: 'Appeals',
    action: 'Start Review',
    actionBy: 'Support Team — Priya Shah',
    permissionScope: 'Appeals',
    environment: 'Production',
    service: 'Admin Console',
    result: 'Success',
    referenceId: 'APL-ACT-000088',
    details: 'Appeal moved New → In Progress',
  },
  {
    id: 'act-7',
    loggedOn: '2026-08-11 03:40 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T03:40:00Z',
    source: 'Support Tickets',
    action: 'Update Ticket Status',
    actionBy: 'Support Team — Priya Shah',
    permissionScope: 'Support Tickets',
    environment: 'Production',
    service: 'Admin Console',
    result: 'Success',
    referenceId: 'ST-ACT-000183',
    details: 'Ticket ST-000183 set to In Progress',
  },
  {
    id: 'act-8',
    loggedOn: '2026-08-11 02:10 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T02:10:00Z',
    source: 'Team Members',
    action: 'Edit Team Member',
    actionBy: 'Platform Owner — Saim Sahi',
    permissionScope: 'Team Members',
    environment: 'Production',
    service: 'Admin Console',
    result: 'Success',
    referenceId: 'TM-ACT-000002',
    details: 'Olivia Brown role updated to Configuration Admin',
  },
  {
    id: 'act-9',
    loggedOn: '2026-08-10 10:15 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T10:15:00Z',
    source: 'Integrations',
    action: 'Test Webhook',
    actionBy: 'Platform Owner — Saim Sahi',
    permissionScope: 'Protected Platform Owner authority',
    environment: 'Production',
    service: 'Stripe Webhooks',
    result: 'Success',
    referenceId: 'INT-ACT-004281',
    details: '—',
  },
  {
    id: 'act-10',
    loggedOn: '2026-08-10 08:05 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T08:05:00Z',
    source: 'Settings',
    action: 'Save Settings',
    actionBy: 'Platform Owner — Saim Sahi',
    permissionScope: 'Settings',
    environment: 'Production',
    service: 'Admin Console',
    result: 'Success',
    referenceId: 'SET-ACT-000044',
    details: 'Regional timezone updated to Australia/Melbourne',
  },
  {
    id: 'act-11',
    loggedOn: '2026-08-10 07:30 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T07:30:00Z',
    source: 'Configuration — Limits & Thresholds',
    action: 'Save Rule',
    actionBy: 'Platform Owner — Saim Sahi',
    permissionScope: 'Configuration',
    environment: 'Production',
    service: 'Admin Console',
    result: 'Success',
    referenceId: 'LTH-ACT-000105',
    details: 'Pro Post Allowance raised to 5',
  },
  {
    id: 'act-12',
    loggedOn: '2026-08-10 06:50 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T06:50:00Z',
    source: 'Keywords',
    action: 'Save Keyword',
    actionBy: 'Development — Alex Morgan',
    permissionScope: 'Keywords Management',
    environment: 'Production',
    service: 'Admin Console',
    result: 'Success',
    referenceId: 'KW-ACT-000144',
    details: 'emergency plumber match type set to Phrase',
  },
  {
    id: 'act-13',
    loggedOn: '2026-08-10 05:15 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T05:15:00Z',
    source: 'Billing & Subscriptions',
    action: 'Add Internal Note',
    actionBy: 'Team Member — Olivia Brown',
    permissionScope: 'Billing & Subscriptions',
    environment: 'Production',
    service: 'Admin Console',
    result: 'Success',
    referenceId: 'BIL-ACT-000214',
    details: 'Internal note added for BUS-000214',
  },
  {
    id: 'act-14',
    loggedOn: '2026-08-10 04:40 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T04:40:00Z',
    source: 'Fraud & Security',
    action: 'Update Case',
    actionBy: 'Security — Riley Chen',
    permissionScope: 'Fraud & Security',
    environment: 'Production',
    service: 'Admin Console',
    result: 'Success',
    referenceId: 'FRD-ACT-000067',
    details: 'Case FRD-000067 marked Decided',
  },
  {
    id: 'act-15',
    loggedOn: '2026-08-10 03:20 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T03:20:00Z',
    source: 'Form Inventory',
    action: 'Save Configuration Rule',
    actionBy: 'Platform Owner — Saim Sahi',
    permissionScope: 'Form Inventory',
    environment: 'Production',
    service: 'Admin Console',
    result: 'Success',
    referenceId: 'FIC-ACT-000008',
    details: 'Business Profile Required Fields activated',
  },
];

export const INITIAL_SYSTEM_ACTIVITY = [
  {
    id: 'prc-1',
    loggedOn: '2026-08-11 10:20:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T10:20:00Z',
    module: 'Configuration — Automation',
    process: 'Automation Run',
    recordId: '—',
    ruleId: 'AUT-0001',
    runId: 'AUR-000001',
    occurrenceId: 'OCC-000184',
    attempt: '1',
    result: 'Completed',
    details: 'Scheduled automation run completed',
  },
  {
    id: 'prc-2',
    loggedOn: '2026-08-11 10:05:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T10:05:00Z',
    module: 'Configuration — Retention',
    process: 'Retention Sweep',
    recordId: 'CUS-000811',
    ruleId: 'RET-0001',
    runId: 'RET-RUN-000044',
    occurrenceId: 'OCC-000190',
    attempt: '1',
    result: 'Completed',
    details: 'Closed Customer account retention check completed',
  },
  {
    id: 'prc-3',
    loggedOn: '2026-08-11 09:50:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T09:50:00Z',
    module: 'Configuration — Routing',
    process: 'Ticket Routing',
    recordId: 'ST-000190',
    ruleId: 'RR-0001',
    runId: 'RTR-000088',
    occurrenceId: 'OCC-000191',
    attempt: '1',
    result: 'Completed',
    details: 'Account Issue ticket routed to Support queue',
  },
  {
    id: 'prc-4',
    loggedOn: '2026-08-11 09:35:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T09:35:00Z',
    module: 'Configuration — Search Matching',
    process: 'Search Evaluation',
    recordId: 'SRCH-004412',
    ruleId: 'SMR-0001',
    runId: 'SMR-RUN-000221',
    occurrenceId: 'OCC-000192',
    attempt: '1',
    result: 'Completed',
    details: 'Platform default search matching applied',
  },
  {
    id: 'prc-5',
    loggedOn: '2026-08-11 09:20:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T09:20:00Z',
    module: 'Configuration — Quote Matching & Distribution',
    process: 'Quote Distribution',
    recordId: 'QT-000533',
    ruleId: 'QMD-0002',
    runId: 'QMD-RUN-000077',
    occurrenceId: 'OCC-000193',
    attempt: '1',
    result: 'Completed',
    details: 'Quote distributed to 8 eligible Businesses',
  },
  {
    id: 'prc-6',
    loggedOn: '2026-08-11 09:05:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T09:05:00Z',
    module: 'Configuration — Lifecycle',
    process: 'Lifecycle Transition',
    recordId: 'POST-004500',
    ruleId: 'LCR-0002',
    runId: 'LCR-RUN-000031',
    occurrenceId: 'OCC-000194',
    attempt: '1',
    result: 'Completed',
    details: 'Stale draft aged per lifecycle rule',
  },
  {
    id: 'prc-7',
    loggedOn: '2026-08-11 08:50:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T08:50:00Z',
    module: 'Configuration — Workflow',
    process: 'Workflow Step',
    recordId: 'ST-000183',
    ruleId: 'WFR-0006',
    runId: 'WFR-RUN-000056',
    occurrenceId: 'OCC-000195',
    attempt: '1',
    result: 'Completed',
    details: 'Support ticket intake workflow advanced',
  },
  {
    id: 'prc-8',
    loggedOn: '2026-08-11 08:35:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T08:35:00Z',
    module: 'Configuration — Notifications',
    process: 'Notification Dispatch',
    recordId: 'NTF-008213',
    ruleId: 'NRL-0003',
    runId: 'NTF-RUN-000902',
    occurrenceId: 'OCC-000196',
    attempt: '1',
    result: 'Completed',
    details: 'Ticket assigned notification dispatched',
  },
  {
    id: 'prc-9',
    loggedOn: '2026-08-11 08:20:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T08:20:00Z',
    module: 'Configuration — Validation',
    process: 'Validation Check',
    recordId: 'BUS-000214',
    ruleId: 'VAL-0005',
    runId: 'VAL-RUN-000140',
    occurrenceId: 'OCC-000197',
    attempt: '1',
    result: 'Completed',
    details: 'ABN format validation passed',
  },
  {
    id: 'prc-10',
    loggedOn: '2026-08-11 08:05:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T08:05:00Z',
    module: 'Configuration — Publishing',
    process: 'Publish Gate',
    recordId: 'POST-004812',
    ruleId: 'PUB-0002',
    runId: 'PUB-RUN-000063',
    occurrenceId: 'OCC-000198',
    attempt: '1',
    result: 'Completed',
    details: 'Publish gate checks completed for new Post',
  },
  {
    id: 'prc-11',
    loggedOn: '2026-08-11 07:50:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T07:50:00Z',
    module: 'Configuration — Flag',
    process: 'Flag Evaluation',
    recordId: 'FLG-SUB-000221',
    ruleId: 'FLG-0003',
    runId: 'FLG-RUN-000118',
    occurrenceId: 'OCC-000199',
    attempt: '1',
    result: 'Completed',
    details: 'Inappropriate content flag evaluated',
  },
  {
    id: 'prc-12',
    loggedOn: '2026-08-11 07:35:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T07:35:00Z',
    module: 'Configuration — Compliance',
    process: 'Compliance Check',
    recordId: 'CMP-000155',
    ruleId: 'CPL-0004',
    runId: 'CPL-RUN-000072',
    occurrenceId: 'OCC-000200',
    attempt: '1',
    result: 'Completed',
    details: 'Licence evidence requirement evaluated',
  },
  {
    id: 'prc-13',
    loggedOn: '2026-08-11 07:20:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T07:20:00Z',
    module: 'Keywords',
    process: 'Keyword Match',
    recordId: 'SRCH-004420',
    ruleId: 'KW-0144',
    runId: 'KW-RUN-000305',
    occurrenceId: 'OCC-000201',
    attempt: '1',
    result: 'Completed',
    details: 'Phrase match applied for emergency plumber',
  },
  {
    id: 'prc-14',
    loggedOn: '2026-08-11 07:05:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T07:05:00Z',
    module: 'Pricing Plans',
    process: 'Price Change Apply',
    recordId: 'PP-PRO',
    ruleId: '—',
    runId: 'PP-RUN-000019',
    occurrenceId: 'OCC-000202',
    attempt: '1',
    result: 'Completed',
    details: 'Scheduled Pro price change applied',
  },
  {
    id: 'prc-15',
    loggedOn: '2026-08-10 22:00:00 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T22:00:00Z',
    module: 'Configuration — Limits & Thresholds',
    process: 'Limit Evaluation',
    recordId: 'BUS-000214',
    ruleId: 'LTH-0105',
    runId: 'LTH-RUN-000210',
    occurrenceId: 'OCC-000203',
    attempt: '1',
    result: 'Completed',
    details: 'Pro post allowance evaluated during publish',
  },
];

export const INITIAL_SECURITY = [
  {
    id: 'sec-1',
    loggedOn: '2026-08-11 10:25:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T10:25:00Z',
    source: 'Configuration — Permissions & Access',
    event: 'Permission Denial',
    affectedUser: 'Team Member — Sample Analyst',
    environment: '—',
    result: 'Denied',
    referenceId: '—',
    details: 'View System Logs not permitted for this assignment',
  },
  {
    id: 'sec-2',
    loggedOn: '2026-08-11 09:10:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T09:10:00Z',
    source: 'Fraud & Security',
    event: 'Session Sign-Out',
    affectedUser: 'Business — Demo Builder Co',
    environment: 'Production',
    result: 'Succeeded',
    referenceId: 'FRD-000067',
    details: 'Active sessions signed out after restriction decision',
  },
  {
    id: 'sec-3',
    loggedOn: '2026-08-11 08:00:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T08:00:00Z',
    source: 'Customers',
    event: 'Account Restriction',
    affectedUser: 'Customer — CUS-000902',
    environment: 'Production',
    result: 'Succeeded',
    referenceId: 'CUS-000902',
    details: 'Account status set to Restricted',
  },
  {
    id: 'sec-4',
    loggedOn: '2026-08-10 16:40:00 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T16:40:00Z',
    source: 'Team Members',
    event: 'Role Change',
    affectedUser: 'Team Member — Olivia Brown',
    environment: 'Production',
    result: 'Succeeded',
    referenceId: 'TM-0002',
    details: 'Role elevated to Configuration Admin',
  },
  {
    id: 'sec-5',
    loggedOn: '2026-08-10 14:15:00 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T14:15:00Z',
    source: 'Settings',
    event: 'MFA Challenge',
    affectedUser: 'Platform Owner — Saim Sahi',
    environment: 'Production',
    result: 'Succeeded',
    referenceId: 'SEC-MFA-000881',
    details: 'Owner MFA challenge completed before Settings save',
  },
  {
    id: 'sec-6',
    loggedOn: '2026-08-10 11:05:00 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T11:05:00Z',
    source: 'Configuration — Permissions & Access',
    event: 'Permission Grant',
    affectedUser: 'Support Officer assignment',
    environment: 'Production',
    result: 'Succeeded',
    referenceId: 'PERM-0001',
    details: 'Review permission added to Support Officer configuration',
  },
];

export const INITIAL_NOTIFICATIONS = [
  {
    id: 'ntf-1',
    loggedOn: '2026-08-11 10:30:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T10:30:00Z',
    eventOccurrenceId: 'EVT-OCC-000921',
    notificationRuleId: 'NRL-0005',
    notificationId: '—',
    deliveryMethod: 'Email',
    scheduledSendNumber: '1',
    deliveryAttempt: '—',
    result: 'Configuration Unavailable',
    details: 'Required technical check unavailable',
  },
  {
    id: 'ntf-2',
    loggedOn: '2026-08-11 10:32:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T10:32:00Z',
    eventOccurrenceId: 'EVT-OCC-000922',
    notificationRuleId: 'NRL-0003',
    notificationId: 'NTF-008213',
    deliveryMethod: 'Email',
    scheduledSendNumber: '—',
    deliveryAttempt: '1',
    result: 'Delivered',
    details: 'Provider confirmed delivery',
  },
  {
    id: 'ntf-3',
    loggedOn: '2026-08-11 09:15:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T09:15:00Z',
    eventOccurrenceId: 'EVT-OCC-000930',
    notificationRuleId: 'NRL-0003',
    notificationId: 'NTF-008220',
    deliveryMethod: 'Dashboard',
    scheduledSendNumber: '—',
    deliveryAttempt: '1',
    result: 'Delivered',
    details: 'Ticket assignment shown in Dashboard',
  },
  {
    id: 'ntf-4',
    loggedOn: '2026-08-11 08:40:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T08:40:00Z',
    eventOccurrenceId: 'EVT-OCC-000931',
    notificationRuleId: 'NRL-0008',
    notificationId: 'NTF-008221',
    deliveryMethod: 'Email',
    scheduledSendNumber: '1',
    deliveryAttempt: '1',
    result: 'Delivered',
    details: 'Compliance approval notice delivered',
  },
  {
    id: 'ntf-5',
    loggedOn: '2026-08-11 07:55:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T07:55:00Z',
    eventOccurrenceId: 'EVT-OCC-000932',
    notificationRuleId: 'NRL-0010',
    notificationId: 'NTF-008222',
    deliveryMethod: 'Browser Push',
    scheduledSendNumber: '—',
    deliveryAttempt: '1',
    result: 'Delivered',
    details: 'Moderation decision push delivered to handler',
  },
  {
    id: 'ntf-6',
    loggedOn: '2026-08-10 18:10:00 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T18:10:00Z',
    eventOccurrenceId: 'EVT-OCC-000910',
    notificationRuleId: 'NRL-0006',
    notificationId: 'NTF-008180',
    deliveryMethod: 'Email',
    scheduledSendNumber: '2',
    deliveryAttempt: '2',
    result: 'Delivered',
    details: 'Appeal review reminder delivered on retry',
  },
];

export const INITIAL_INTEGRATIONS = [
  {
    id: 'int-1',
    loggedOn: '2026-08-11 10:35:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T10:35:00Z',
    service: 'Stripe Webhooks',
    event: 'Webhook',
    environment: 'Production',
    correlationId: 'COR-008770',
    requestReference: 'REQ-8F21',
    providerReference: 'evt_8F21',
    result: 'Processed',
    details: 'Webhook accepted',
  },
  {
    id: 'int-2',
    loggedOn: '2026-08-11 09:00:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T09:00:00Z',
    service: 'Stripe Billing',
    event: 'Invoice Paid',
    environment: 'Production',
    correlationId: 'COR-008801',
    requestReference: 'REQ-9A10',
    providerReference: 'in_9A10',
    result: 'Processed',
    details: 'Subscription invoice for BUS-000214 recorded',
  },
  {
    id: 'int-3',
    loggedOn: '2026-08-11 07:45:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T07:45:00Z',
    service: 'Email Provider',
    event: 'Delivery Receipt',
    environment: 'Production',
    correlationId: 'COR-008812',
    requestReference: 'REQ-EM44',
    providerReference: 'msg_EM44',
    result: 'Processed',
    details: 'Notification delivery receipt accepted',
  },
  {
    id: 'int-4',
    loggedOn: '2026-08-10 20:15:00 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T20:15:00Z',
    service: 'Stripe Webhooks',
    event: 'Subscription Updated',
    environment: 'Production',
    correlationId: 'COR-008690',
    requestReference: 'REQ-7C90',
    providerReference: 'evt_7C90',
    result: 'Processed',
    details: 'Pending price change mirrored from Stripe',
  },
];

export const INITIAL_API = [
  {
    id: 'api-1',
    loggedOn: '2026-08-11 10:40:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T10:40:00Z',
    service: 'ABN Lookup Web Services',
    endpoint: 'ABN Lookup',
    environment: 'Production',
    correlationId: '—',
    requestReference: 'ABN-REQ-00412',
    providerReference: '—',
    result: 'Succeeded',
    details: 'Lookup completed',
  },
  {
    id: 'api-2',
    loggedOn: '2026-08-11 09:25:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T09:25:00Z',
    service: 'Location Services',
    endpoint: 'Suburb Resolve',
    environment: 'Production',
    correlationId: 'LOC-CORR-00088',
    requestReference: 'LOC-REQ-00088',
    providerReference: '—',
    result: 'Succeeded',
    details: 'Search suburb resolved for matching',
  },
  {
    id: 'api-3',
    loggedOn: '2026-08-11 08:10:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T08:10:00Z',
    service: 'Media Storage',
    endpoint: 'Upload Asset',
    environment: 'Production',
    correlationId: 'MED-CORR-00055',
    requestReference: 'MED-REQ-00055',
    providerReference: 'blob_55',
    result: 'Succeeded',
    details: 'Post portfolio image stored',
  },
  {
    id: 'api-4',
    loggedOn: '2026-08-10 15:30:00 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T15:30:00Z',
    service: 'ABN Lookup Web Services',
    endpoint: 'ABN Lookup',
    environment: 'Production',
    correlationId: '—',
    requestReference: 'ABN-REQ-00408',
    providerReference: '—',
    result: 'Succeeded',
    details: 'Compliance submission ABN verified',
  },
];

export const INITIAL_HEALTH = [
  {
    id: 'hlt-1',
    loggedOn: '2026-08-11 10:45:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T10:45:00Z',
    source: 'Platform Database',
    component: 'Azure Database for PostgreSQL',
    fault: 'Connection Unavailable',
    environment: 'Production',
    referenceId: 'HLT-000184',
    result: 'Failed',
    details: 'Connection check timed out',
  },
  {
    id: 'hlt-2',
    loggedOn: '2026-08-11 10:52:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T10:52:00Z',
    source: 'Background Queue',
    component: 'Background Queue',
    fault: 'Queue Recovered',
    environment: 'Production',
    referenceId: 'HLT-000186',
    result: 'Recovered',
    details: 'Queue processing returned to normal',
  },
  {
    id: 'hlt-3',
    loggedOn: '2026-08-11 06:15:00 UTC',
    loggedOnDate: '2026-08-11',
    loggedOnInstant: '2026-08-11T06:15:00Z',
    source: 'Notification Pipeline',
    component: 'Email Dispatcher',
    fault: 'Provider Latency',
    environment: 'Production',
    referenceId: 'HLT-000190',
    result: 'Degraded',
    details: 'Email provider latency elevated; deliveries delayed',
  },
  {
    id: 'hlt-4',
    loggedOn: '2026-08-10 21:00:00 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T21:00:00Z',
    source: 'Search Index',
    component: 'Search Matching Index',
    fault: 'Index Rebuild',
    environment: 'Production',
    referenceId: 'HLT-000175',
    result: 'Recovered',
    details: 'Nightly search index rebuild completed',
  },
  {
    id: 'hlt-5',
    loggedOn: '2026-08-10 19:30:00 UTC',
    loggedOnDate: '2026-08-10',
    loggedOnInstant: '2026-08-10T19:30:00Z',
    source: 'Background Queue',
    component: 'Retention Worker',
    fault: 'Worker Restart',
    environment: 'Production',
    referenceId: 'HLT-000170',
    result: 'Recovered',
    details: 'Retention worker restarted after idle timeout',
  },
];

export function buildLogFilterOptions(rows, key) {
  const values = [
    ...new Set(
      (rows || [])
        .map((row) => row?.[key])
        .filter((value) => value != null && String(value).trim() !== ''),
    ),
  ].sort((a, b) => String(a).localeCompare(String(b)));
  return ['All', ...values];
}
